import eventBus from '@/utilities/EventBus';

const methods = {
  showToast(options) {
    eventBus.$emit('acv::showToastMessage', options);
  },
  showErrorToast(message, options = {}) {
    this.showToast({
      header: 'There was a problem.',
      severity: 'error',
      message,
      ...options,
    });
  },
  showSuccessToast(message, options = {}) {
    this.showToast({
      header: 'Success.',
      severity: 'success',
      message,
      ...options,
    });
  },
  showInfoToast(message, options = {}) {
    this.showToast({
      severity: 'info',
      message,
      ...options,
    });
  },
  showWarningToast(message, options = {}) {
    this.showToast({
      header: 'Alert.',
      severity: 'warning',
      message,
      ...options,
    });
  },
  clearToastMessageById(id) {
    eventBus.$emit('acv::clearToastMessageById', id);
  },
};

export default {
  methods,
};
